jQuery(document).ready(function ($) {
  var cookieName = "hideAlertBar";

  $(".alert-bar__close").click(function (e) {
    $(".alert-bar__wrapper").addClass("dismissed");
    var ONE_DAY = 24 * 60 * 60;
    var SEVEN_DAYS = ONE_DAY * 7;
    var maxAge = "max-age=" + SEVEN_DAYS;
    var newCookie = cookieName + "=true;" + maxAge;
    document.cookie = newCookie;
  });

  var allCookies = document.cookie;

  // this all runs on document ready - alert bar starts hidden and if no cookie present brings it to life!
  // if string has length
  if (allCookies) {
    var cookieNameExists = allCookies.indexOf(cookieName);

    // if cookie name doesn't exist, then show the banner
    if (cookieNameExists === -1) {
      $(".alert-bar__wrapper").removeClass("dismissed");
    }
  } else {
    // if no cookies present, show the alert bar
    $(".alert-bar__wrapper").removeClass("dismissed");
  }
});
